/* global femcare */

femcare.shared.progressBar = {

    /**
     * Initializes a scroll progress bar for a specified container.
     * @param {string | Element} containerSelector - A CSS selector or DOM element for the container with scrollable content.
     * @param {string | Element} progressBarSelector - A CSS selector or DOM element for the progress bar.
     */
    init: function (containerSelector, progressBarSelector) {
        const container = typeof containerSelector === 'string' ? document.querySelector(containerSelector) : containerSelector;
        const progressBarContainer = typeof progressBarSelector === 'string' ? document.querySelector(progressBarSelector) : progressBarSelector;

        const progressBar = progressBarContainer.querySelector('.progress-scroll');

        const updateProgressBar = () => {
            const scrollWidth = container.scrollWidth;
            const clientWidth = container.clientWidth;
            const scrollLeft = container.scrollLeft;
            const scrolledPercentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
            progressBar.style.width = `${scrolledPercentage}%`;
        };

        const checkForOverflow = () => {
            const isOverflowing = container.scrollWidth > container.clientWidth;
            progressBarContainer.classList.toggle('visible', isOverflowing);
            if (isOverflowing) {
                updateProgressBar(); // Initialize progress based on initial scroll position
            }
        };

        container.addEventListener('scroll', updateProgressBar);
        window.addEventListener('resize', checkForOverflow);

        checkForOverflow(); // Initial check to determine if the progress bar should be shown
    }
}
